export const Colors = ["#1ec891", "#ff725e", "#ffd05b"];


export const constants = {
    urlLocal: "https://api.aviario.aleburgos.es/api/",
    //urlLocal: "http://localhost:3001/api/",
}